import { render, staticRenderFns } from "./ExternalLinksModal.vue?vue&type=template&id=0af53ae0&"
import script from "./ExternalLinksModal.vue?vue&type=script&lang=js&"
export * from "./ExternalLinksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports